import type { ReactNode } from 'react';
import {
  DatePicker,
  Select,
  Switch,
  type PlainDate,
} from '@viquard/doc-ui/components';
import { useCalendarMessages } from '../../i18n.js';
import { buildRecurOptions } from './helpers.js';
import { FieldRow, Section } from './layout.js';

export interface RepeatSectionProps {
  readonly enabled: boolean;
  readonly recurring: boolean;
  readonly recurrence: string;
  readonly recurrenceUntil: PlainDate | null;
  readonly onRecurringChange: (next: boolean) => void;
  readonly onRecurrenceChange: (next: string) => void;
  readonly onRecurrenceUntilChange: (next: PlainDate | null) => void;
  readonly locale?: string | undefined;
}

export function RepeatSection(props: RepeatSectionProps): ReactNode {
  const messages = useCalendarMessages();
  if (!props.enabled) return null;
  return (
    <Section title={messages.composerSectionRepeat}>
      <div className="vq-cal__composer-repeat">
        <label className="vq-cal__composer-toggle">
          <Switch checked={props.recurring} onCheckedChange={props.onRecurringChange} />
          <span>{messages.composerRepeatLabel}</span>
        </label>
        {props.recurring && (
          <div className="vq-cal__composer-repeat-fields">
            <FieldRow label={messages.composerRepeatFrequencyLabel} filled>
              <Select
                options={buildRecurOptions(messages)}
                value={props.recurrence}
                onValueChange={props.onRecurrenceChange}
                size="md"
              />
            </FieldRow>
            <FieldRow
              label={messages.composerRepeatUntilLabel}
              filled={props.recurrenceUntil !== null}
            >
              <DatePicker
                value={props.recurrenceUntil}
                onChange={props.onRecurrenceUntilChange}
                placeholder={messages.composerRepeatUntilPlaceholder}
                clearLabel={messages.composerDatePickerClear}
                dialogLabel={messages.composerDatePickerDialogLabel}
                {...(props.locale !== undefined ? { locale: props.locale } : {})}
                size="md"
                clearable
              />
            </FieldRow>
          </div>
        )}
      </div>
    </Section>
  );
}
